var version = {
    "name":      "dativery",
    "buildDateCode": "20251216-152951",
    "buildDate": "Tue Dec 16 2025 15:29:51 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251216-152951",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;